// extracted by mini-css-extract-plugin
module.exports = {"container":"_2P76az4CGaLBbCycQn4_0c"};